import styled from 'react-emotion';
import { theme } from '@ublend-npm/aulaui-next';
import { styled as styledCore } from '@ublend-npm/aulaui-core';
import { DARK } from '@core/constants/theme';

export const Container = styled('div')`
  display: flex;
  align-items: center; /* always align center for avatar + text inline */
`;

export const Description = styled('div')`
  display: flex;
  align-items: center;
  font-family: 'Roboto', sans-serif;
  font-size: ${theme.font.size.copy};
  line-height: ${theme.font.size.copy};
  margin-left: ${theme.spacing.xSmall};
  gap: 8px;
`;

export const Title = styled('span')`
  font-weight: ${({ bold }) =>
    bold ? theme.font.weight.bold : theme.font.weight.regular};
  color: ${theme.color.mediumBlue};
`;

export const Subtitle = styledCore('span')(({ theme: themeII }) => ({
  fontFamily: 'Roboto, sans-serif',
  color:
    themeII.palette.mode === DARK
      ? 'rgba(255, 255, 255, 0.7) !important'
      : 'rgba(0, 0, 0, 0.6) !important',
  // marginLeft: '0.5rem',
  fontSize: '0.75rem',

  '& span': {
    color:
      themeII.palette.mode === DARK
        ? 'rgba(255, 255, 255, 0.7) !important'
        : 'rgba(0, 0, 0, 0.6) !important',
  },
}));
